import React from 'react';

import { useTranslation } from 'react-i18next';

import StatusIndicator from 'components/application/indicators/StatusIndicator';
import Tooltip from 'components/application/Tooltip';

export default function PersonnelTrainingStatusIndicator({ status }) {
  const { t: i18nTCommon } = useTranslation('common');

  const trainingStatusAndTooltip = {
    0: { status: 'high', tooltip: i18nTCommon('training.trainingIsMissing') },
    1: { status: 'high', tooltip: i18nTCommon('shared.expiryDateIsMissing') },
    2: { status: 'high', tooltip: i18nTCommon('training.trainingHasExpired') },
    3: {
      status: 'medium',
      tooltip: i18nTCommon('training.trainingIsExpiringSoon'),
    },
    4: { status: 'low', tooltip: i18nTCommon('training.trainingIsUpToDate') },
    5: { status: 'grey', tooltip: i18nTCommon('training.noRequiredTraining') },
    archived: { status: 'hollow', tooltip: i18nTCommon('personnel.archived') },
  }[status];

  return (
    <div className='tooltip-parent tw-flex'>
      <StatusIndicator status={trainingStatusAndTooltip?.status} />
      <Tooltip
        placement='top'
        tooltip={trainingStatusAndTooltip?.tooltip}
        trigger='hover'
      />
    </div>
  );
}
